import { BaseService } from "../../core/baseService";
import {
  LateCheckoutServiceInterface,
  GetLateCheckoutRequestsParams,
  UpdateLateCheckoutStatusParams,
} from "../types/lateCheckout.types";
import { AdminLateCheckoutRequestDto } from "../../../models/AdminLateCheckoutRequestDto";
import { PaginatedResponse } from "../../../models";
import { ApiResult, CountResponse, extractCount } from "../../core/types";

export class LateCheckoutService
  extends BaseService
  implements LateCheckoutServiceInterface
{
  async getPendingCount(): Promise<ApiResult<number>> {
    const result = await this.handleRequest<CountResponse>(
      this.client.get("/api/admin/late-checkout-requests/pending-count"),
    );
    return extractCount(result);
  }

  async getRequests(
    params: GetLateCheckoutRequestsParams,
  ): Promise<ApiResult<PaginatedResponse<AdminLateCheckoutRequestDto>>> {
    const queryParams = this.buildQueryParams({
      pageNumber: params.page,
      pageSize: params.pageSize,
      status: params.status,
      roomNumber: params.roomFilter,
    });

    return this.handleRequest<PaginatedResponse<AdminLateCheckoutRequestDto>>(
      this.client.get("/api/admin/late-checkout-requests", {
        params: queryParams,
      }),
    );
  }

  async updateStatus(
    params: UpdateLateCheckoutStatusParams,
  ): Promise<ApiResult<AdminLateCheckoutRequestDto>> {
    const { requestId, newStatus, adminNotes } = params;

    return this.handleRequest<AdminLateCheckoutRequestDto>(
      this.client.put(`/api/admin/late-checkout-requests/${requestId}/status`, {
        newStatus,
        adminNotes,
      }),
    );
  }
}
